export class OrderSummary
{
  constructor(form, element, route) {
    this.form = form;
    this.element = element;
    this.route = route;

    this.bindEvents();
    this.refresh();
  }

  bindEvents() {
    [...document.querySelectorAll('[data-update-order-summary]')].forEach((element) => {
      element.addEventListener('change', () => this.refresh());
    });
  }

  refresh() {
    let body = new FormData(this.form);

    fetch(this.route, {
      body,
      credentials: 'include',
      method: 'POST'
    }).then((res) => res.text())
      .then((text) => {
        this.element.innerHTML = text;
        [...this.element.querySelectorAll('select, input, textarea')].forEach((element) => {
          element.addEventListener('change', () => this.refresh());
        });
      });
  }
}
